import { render, staticRenderFns } from "./AsorRbuItem.vue?vue&type=template&id=ff11a7f2&scoped=true"
import script from "./AsorRbuItem.vue?vue&type=script&lang=js"
export * from "./AsorRbuItem.vue?vue&type=script&lang=js"
import style0 from "./AsorRbuItem.vue?vue&type=style&index=0&id=ff11a7f2&prod&lang=scss"
import style1 from "./AsorRbuItem.vue?vue&type=style&index=1&id=ff11a7f2&prod&scoped=true&lang=css"
import style2 from "./AsorRbuItem.vue?vue&type=style&index=2&id=ff11a7f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff11a7f2",
  null
  
)

export default component.exports